import axios from '@/libs/api.request'
import config from '@/config'

const baseUrl = `${config.baseContainerUrl}/api/v1/`

export const getContainerStacks = (params) => {
  return axios.request({
    url: `${baseUrl}stack/`,
    params: params,
    method: 'get'
  })
}

export const createContainerStack = (data, id) => {
  let url = `${baseUrl}stack/`
  let method = 'post'
  if (id) {
    url += `${id}/`
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const detailContainerStack = (id) => {
  return axios.request({
    url: `${baseUrl}stack/${id}/`,
    method: 'get'
  })
}

export const deleteContainerStack = (id) => {
  return axios.request({
    url: `${baseUrl}stack/${id}/`,
    method: 'delete'
  })
}

export const getContainerStackDeployTasks = (params) => {
  return axios.request({
    url: `${baseUrl}stack_deploy_task/`,
    params: params,
    method: 'get'
  })
}

export const detailContainerStackDeployTask = (id) => {
  return axios.request({
    url: `${baseUrl}stack_deploy_task/${id}/`,
    method: 'get'
  })
}

export const deployContainerStack = (data, id) => {
  return axios.request({
    url: `${baseUrl}stack/${id}/deploy/`,
    data: data,
    method: 'post'
  })
}

export const stopDeployContainerStack = (data, id) => {
  return axios.request({
    url: `${baseUrl}stack/${id}/stop_deploy/`,
    data: data,
    method: 'post'
  })
}
